import React from 'react';

import {openSampleSequence} from 'actions/OnboardingActions';

import * as analytics from 'analytics/Analytics';
import FeaturePreviewScreen from './FeaturePreviewScreen';
import * as NewUserFlowActions from './NewUserFlowActions';

export const MOL_BIO_OVERVIEW_HEADER = 'Molecular Biology Suite';
const MOL_BIO_FEATURE_INFOS = [
  {
    header: 'Share plasmids and oligos with your entire lab',
    text: `
      Benchling is built for collaboration. Use shared feature libraries to auto-annotate your sequences
      and shared oligo folders to design your primers.
    `,
    imageName: 'sharing.png',
  },
  {
    header: 'Easily align your sequences',
    text: `
      Use our powerful sequence alignment tool to perform consensus and template alignments. The results are
      stored alongside your plasmids for ease of use.
    `,
    imageName: 'alignments.png',
  },
  {
    header: 'Never lose data again',
    text: `
      All of your files are version controlled and timestamped - just click on the history panel to see
      your edits. Export all of your data in just a few clicks.
    `,
    imageName: 'version-history.png',
  },
];

const handleClickNextScreen = () => {
  analytics.track('onboarding_page', 'clicked', {
    page: 'molecular_biology_overview',
    objectClicked: 'button',
    objectText: 'Next',
    eventLastModified: 'FY21_Q1a2',
  });
  NewUserFlowActions.hideScreen();
  openSampleSequence();
};

const handleChangeActiveSection = (activeFeatureInfoText) => {
  analytics.track('onboarding_page', 'clicked', {
    page: 'molecular_biology_overview',
    objectClicked: 'button',
    objectText: activeFeatureInfoText,
    eventLastModified: 'FY21_Q1a2',
  });
};

const MolBioInfoScreen = () => (
  <FeaturePreviewScreen
    header={MOL_BIO_OVERVIEW_HEADER}
    subheader={
      <span>
        Projects can contain different types of files, like oligos, DNA sequences, and AA sequences.
      </span>
    }
    featureInfos={MOL_BIO_FEATURE_INFOS}
    nextButtonText="Next"
    handleClickNextScreen={handleClickNextScreen}
    onChangeActiveSection={handleChangeActiveSection}
  />
);

export default MolBioInfoScreen;
